import { render, staticRenderFns } from "./LinkComponent.vue?vue&type=template&id=091cf54b"
import script from "./LinkComponent.vue?vue&type=script&lang=js"
export * from "./LinkComponent.vue?vue&type=script&lang=js"
import style0 from "./LinkComponent.vue?vue&type=style&index=0&id=091cf54b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports